'use client';

import { useLoginState } from '@packages/shared/src/hooks/useLoginState/useLoginState';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';

const DynamicGeoCountryLayer = dynamic(
  () =>
    import(/* webpackChunkName: 'CMS_GeoCountryLayer' */ './GeoCountryLayer').then(
      (mod) => mod.GeoCountryLayer,
    ),
  {
    ssr: false,
  },
);

export const GeoCountryLayerLoader = ({
  geoCountryHeaderCode,
}: {
  geoCountryHeaderCode: string | null;
}) => {
  const searchParams = useSearchParams();
  const { loggedIn, softLoggedIn } = useLoginState();
  // INSPIRE-4123 do not show the layer if the user is logged in or soft logged in
  if (loggedIn || softLoggedIn) {
    return null;
  }

  const geoCountryCode =
    !Array.isArray(geoCountryHeaderCode) && searchParams?.get('skipCountryLayer') !== 'true'
      ? geoCountryHeaderCode
      : undefined;

  return <DynamicGeoCountryLayer geoCountryCode={geoCountryCode ?? undefined} />;
};
